import React, {Component} from 'react'
import { translate } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import Image from '../../global/media/Image'

import ArrowCtaRed from '../../../static/svgs/arrow-cta-red.svg';
import ArrowCtaBlue from '../../../static/svgs/arrow-cta-blue.svg';

import { ImageGalleryWrapper, ImageGalleryList, ImageGalleryItemWrapper, ImageGalleryCity, ImageGalleryState, ButtonsWrapper, PrevButton, NextButton } from './styled-components'

@inject("store")
@observer class ImageGallery extends Component {
  constructor(props) {
    super(props)

    this.state = {
      scrollAmount: 0,
      scrollWidth: 0
    }

    this.gaGalleryPrevClicked = this.gaGalleryPrevClicked.bind(this)
    this.gaGalleryNextClicked = this.gaGalleryNextClicked.bind(this)
    this.horizontalScroll = this.horizontalScroll.bind(this)
  }

  gaGalleryPrevClicked() {
    window.dataLayer.push({
      'event': 'image-gallery:click',
      'nav': 'carousel',
      'navItem': 'previous'
    });
  }

  gaGalleryNextClicked() {
    window.dataLayer.push({
      'event': 'image-gallery:click',
      'nav': 'carousel',
      'navItem': 'next'
    });
  }

  horizontalScroll (direction) {
    const container = document.querySelector('#image-gallery-container')
    const containerWidth = container.getBoundingClientRect().width
    const listItem = document.querySelector('.image-gallery__item')
    const imageWidth = listItem.getBoundingClientRect().width
    const imagesCount = this.props.data.images.length
    const scrollWidth = (imagesCount * imageWidth) - imageWidth
    console.log("scrollWidth", scrollWidth);
    console.log("-scrollWidth", -scrollWidth);
    const scrollAmount = Math.round(this.state.scrollAmount)
    console.log("scrollAmount", scrollAmount);

    if (direction == 'next') {
      -scrollWidth < this.state.scrollAmount &&
      this.setState({
        scrollAmount: (this.state.scrollAmount - (containerWidth - (containerWidth - imageWidth))),
        scrollWidth: scrollWidth
      })
      this.gaGalleryNextClicked()
    } else {
      this.setState({scrollAmount: (this.state.scrollAmount + (containerWidth - (containerWidth - imageWidth)))})
      this.gaGalleryPrevClicked()
    }
  }

  render() {
    const { horizontalScroll } = this
    const { scrollAmount, scrollWidth } = this.state
    const { data, imageDictionary, store, t } = this.props

    return (
      <ImageGalleryWrapper id='image-gallery-container'>
        <h2>{t('imageGallery.title')}</h2>
        <ImageGalleryList id='image-gallery-list'>
          {
            data.images.map((image, index) => (
              <li className='image-gallery__item' key={index} style={{transform: `translateX(${scrollAmount.toFixed(3)}px)`}}>
                <ImageGalleryItemWrapper>
                  <Image aspectHeight={10} aspectWidth={7} sizes={imageDictionary[image.asset].sizes} />
                  <ImageGalleryCity>{image.city}</ImageGalleryCity>
                  <ImageGalleryState>{image.state}</ImageGalleryState>
                </ImageGalleryItemWrapper>
              </li>
            ))
          }
        </ImageGalleryList>
        <ButtonsWrapper>
          <PrevButton disabled={scrollAmount >= 0 ? true : false} onClick={() => horizontalScroll('prev')}><ArrowCtaBlue /><span>{t('imageGallery.prev')}</span></PrevButton>
          <NextButton disabled={scrollWidth > 1 && scrollAmount === -scrollWidth ? true : false} onClick={() => horizontalScroll('next')}><ArrowCtaRed /><span>{t('imageGallery.next')}</span></NextButton>
        </ButtonsWrapper>
      </ImageGalleryWrapper>
    )
  }
}

export default translate()(ImageGallery)



// WEBPACK FOOTER //
// ./src/components/modules/ImageGallery/ImageGallery.js